import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PinStateIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12.007 2C8.15104 2 5.01404 5.137 5.01404 8.993C5.01404 13.476 10.982 21.206 11.236 21.513C11.75 22.159 12.264 22.159 12.778 21.513C13.032 21.205 19 13.476 19 8.993C19 5.136 15.863 2 12.007 2ZM9.87904 11.121C10.27 11.511 10.27 12.144 9.87904 12.535C9.68404 12.73 9.42804 12.828 9.17204 12.828C8.91604 12.828 8.66004 12.73 8.46504 12.535C7.52104 11.592 7.00004 10.336 7.00004 9C7.00004 7.664 7.52104 6.408 8.46504 5.465C8.85604 5.074 9.48804 5.074 9.87904 5.465C10.27 5.856 10.27 6.489 9.87904 6.879C9.31304 7.445 9.00004 8.198 9.00004 9C9.00004 9.802 9.31304 10.555 9.87904 11.121ZM12.007 9.99C11.455 9.99 11.007 9.542 11.007 8.99C11.007 8.438 11.455 7.99 12.007 7.99C12.559 7.99 13.007 8.438 13.007 8.99C13.007 9.542 12.559 9.99 12.007 9.99ZM14.828 12.828C14.572 12.828 14.316 12.73 14.121 12.535C13.73 12.144 13.73 11.511 14.121 11.121C14.688 10.555 15 9.802 15 9C15 8.198 14.687 7.445 14.121 6.879C13.73 6.489 13.73 5.856 14.121 5.465C14.512 5.074 15.144 5.074 15.535 5.465C16.479 6.408 17 7.664 17 9C17 10.336 16.479 11.592 15.535 12.535C15.34 12.73 15.084 12.828 14.828 12.828Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PinStateIcon.propTypes = {
  sx: PropTypes.object,
};

export default PinStateIcon;
